/* global $ */

const PASSWORD_FIELD = '.password-field'
const PASSWORD_FIELD_INPUT = '.password-field__input'
const PASSWORD_FIELD_TOGGLE_CLASS = 'password-field--show-text'
const PASSWORD_FIELD_ICON_SELECTOR = '.password-field__icon'

export default class PasswordFieldWidget {
  constructor() {
    this.$passwordField = $(PASSWORD_FIELD)
    this.$formElement = this.$passwordField.find(PASSWORD_FIELD_INPUT)
    this.$icon = this.$passwordField.find(PASSWORD_FIELD_ICON_SELECTOR)
    this.initBehavior()
  }

  initBehavior() {
    this.$icon.on('click', this.showText.bind(this))
  }

  showText() {
    this.toggleIcon()
    this.changeInputType()
  }

  toggleIcon() {
    this.$passwordField.toggleClass(PASSWORD_FIELD_TOGGLE_CLASS)
  }

  changeInputType() {
    if (this.$formElement.attr('type') === 'password') {
      this.$formElement.attr({ type: 'text' })
    } else {
      this.$formElement.attr({ type: 'password' })
    }
  }
}
